export interface HeaderHeights {
  large: number;
  medium: number;
  small: number;
}

export const primaryHeaderHeights = {
  large: 80,
  medium: 60,
  small: 60,
};

export const reducedHeaderFirstRowHeightFactors = {
  large: (1 / 2),
  medium: (2 / 3),
  small: (2 / 3),
};

export const reducedLogoHeightFactor = 0.5;

export const reducedPrimaryHeaderHeights = {
  large: primaryHeaderHeights.large * reducedHeaderFirstRowHeightFactors.large,
  medium: primaryHeaderHeights.medium * reducedHeaderFirstRowHeightFactors.medium,
  small: primaryHeaderHeights.small * reducedHeaderFirstRowHeightFactors.small,
};
export const secondaryHeaderHeight = 40;
export const notActiveLinkIdleColor = (isHoveredLink: boolean, hoverOtherLinksColors: string, idleColor: string) => (
  isHoveredLink ? hoverOtherLinksColors : idleColor
);

export const getHeaderHeights = (isSecondaryHeaderEnabled: boolean) => (isSecondaryHeaderEnabled ? {
  large: secondaryHeaderHeight + primaryHeaderHeights.large,
  medium: secondaryHeaderHeight + primaryHeaderHeights.medium,
  small: secondaryHeaderHeight + primaryHeaderHeights.small,
} : primaryHeaderHeights);

export const getReducedHeaderHeights = (isSecondaryHeaderEnabled: boolean) => (isSecondaryHeaderEnabled ? {
  large: secondaryHeaderHeight + reducedPrimaryHeaderHeights.large,
  medium: secondaryHeaderHeight + reducedPrimaryHeaderHeights.medium,
  small: secondaryHeaderHeight + reducedPrimaryHeaderHeights.small,
} : reducedPrimaryHeaderHeights);
